import React, { useState } from "react";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { DesktopLayout } from "@/layouts";
import { PositionDetailDrawerDesktop } from "@/pages/positions/drawers";
import { ClosedPositionData } from "@crypto-trading/common/browser";
import { ClosedPositionsPanel, StatisticsCards } from "@/components/StatisticsSections";

export const StatisticsPageDesktop: React.FC = () => {
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString() || "";
  const [selectedPosition, setSelectedPosition] =
    useState<ClosedPositionData | null>(null);

  return (
    <>
      <DesktopLayout
        pageTitle="Statistics"
        pageDescription="Track your trading activity and performance across all exchanges."
        showRightSidebar={false}
      >
        <div className="flex flex-col gap-8">
          <StatisticsCards userId={userId} />
          <ClosedPositionsPanel userId={userId} onSelect={setSelectedPosition} />
        </div>
      </DesktopLayout>

      <PositionDetailDrawerDesktop
        userId={userId}
        position={selectedPosition}
        open={!!selectedPosition}
        onOpenChange={(open) => !open && setSelectedPosition(null)}
        onPositionUpdate={(updatedPosition) =>
          setSelectedPosition(updatedPosition as ClosedPositionData)
        }
        source="positions_page"
      />
    </>
  );
};
